import React, { useState, useEffect, useRef } from "react";
import Navbar2 from "../Header/Navbar2";
import pencil from "../../Assets/img/vector/pencil.png";
import Modal from "react-modal";

import userimage from "../../Assets/img/authors/profileImage.png";

import axios from "axios";
import { BASE_URL, security_key } from "../../global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import LinearProgress from "@mui/material/LinearProgress";

const EditUserProfile = () => {
    const history = useNavigate();
    const [isEditing, setIsEditing] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [image, setImage] = useState("https://cdn-icons-png.flaticon.com/128/3135/3135715.png");
    const [formData, setFormData] = useState([]);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const formRef = useRef(null);

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getUserData",
            pk_user_key: sessionStorage.getItem("pk_user_key"),
        });

        const output = response.data;

        if (output) {
            setFormData(output);
        }
    };

    const formik = useFormik({
        initialValues: {
            pk_ud_key: formData ? formData.pk_ud_key : "",
            first_name: formData ? formData.first_name : "",
            last_name: formData ? formData.last_name : "",
            user_email: formData ? formData.user_email : "",
            dob: formData ? formData.dob : "",
            user_img: null,
            user_img_mod: formData && formData.user_img_mod ? BASE_URL + "API/uploads/images/" + formData.user_img_mod : "",
            updated_by: sessionStorage.getItem("pk_user_key"),
            fk_user_key: sessionStorage.getItem("pk_user_key"),
            phone: formData && formData.phone ? formData.phone : "",
            address_line1: formData ? formData.address_line1 : "",
            address_line2: formData ? formData.address_line2 : "",
            country: formData ? formData.country : "",
            state: formData ? formData.state : "",
            city: formData ? formData.city : "",
            zip_code: formData ? formData.zip_code : "",
            // google: formData ? formData.google : "",
            website: formData ? formData.website : "",
            facebook: formData ? formData.facebook : "",
            twitter: formData ? formData.twitter : "",
            instagram: formData ? formData.instagram : "",
            pinterest: formData ? formData.pinterest : "",
            linkedin: formData ? formData.linkedin : "",
            gender: formData ? (formData.gender === 1 ? "1" : formData.gender === 2 ? "2" : "") : "",
            visibility: 1,
        },
        validationSchema: Yup.object().shape({
            first_name: Yup.string()
                .min(2, "First Name must be at least 2 characters.")
                .max(50, "First Name must be at most 50 characters.")
                .matches(/^[a-zA-Z\s]*$/, "First Name can only contain letters and spaces.")
                .required("First Name is required."),

            last_name: Yup.string()
                .min(2, "Last Name must be at least 2 characters.")
                .max(50, "Last Name must be at most 50 characters.")
                .matches(/^[a-zA-Z\s]*$/, "Last Name can only contain letters and spaces.")
                .required("Last Name is required."),

            user_email: Yup.string().email("Invalid email format.").max(255, "Email must be at most 255 characters.").required("Email is required."),

            gender: Yup.number().oneOf([1, 2], "Gender must be either 1 (Male) or 2 (Female).").required("Gender is required."),

            address_line1: Yup.string().max(100, "Address Line 1 must be at most 100 characters.").required("Address Line 1 is required."),

            address_line2: Yup.string().max(100, "Address Line 2 must be at most 100 characters."),

            country: Yup.string().max(50, "Country must be at most 50 characters.").required("Country is required."),

            city: Yup.string().max(50, "City must be at most 50 characters.").required("City is required."),

            state: Yup.string().max(50, "State must be at most 50 characters.").required("State is required."),

            zip_code: Yup.string()
                .matches(/^\d{5}(-\d{4})?$/, "Zipcode must be a 5-digit number or a 5+4 format (e.g., 12345 or 12345-6789).")
                .required("Zipcode is required."),
            dob: Yup.date()
                .required("Date of Birth is required.")
                .max(new Date(), "Date of Birth cannot be in the future.")
                .test("age", "You must be at least 18 years old.", (value) => {
                    if (!value) return false;
                    const today = new Date();
                    const birthDate = new Date(value);
                    const age = today.getFullYear() - birthDate.getFullYear();
                    const monthDiff = today.getMonth() - birthDate.getMonth();
                    return age > 18 || (age === 18 && monthDiff >= 0);
                }),

            phone: Yup.string()
                .required("Phone number is required.")
                .min(11, "Phone number must be at least 10 digits.")
                .max(16, "Phone number must not exceed 15 digits.")
                .test("unique-digits", "Invalid phone number.", function (value) {
                    const cleanedDigits = value.replace(/^\+\D*/, "");
                    const digitsWithoutCountryCode = cleanedDigits.slice(1);
                    const hasDifferentDigit = Array.from(new Set(digitsWithoutCountryCode)).length !== 1;
                    return hasDifferentDigit || this.createError({ message: "Invalid phone number." });
                }),

            // mag_logo_mod: Yup.mixed().required("Magazine Image is required."),
        }),
        enableReinitialize: true,
        onSubmit: async (values) => {
            toast.dismiss();

            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "updateProfileData",
                    ...values,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output == 1) {
                toast.success("Updated successfully!");
                setTimeout(() => history("/profile"), 3000);
            } else {
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });

    const setFieldValue = formik.setFieldValue;

    const handleImageChange = (event) => {
        const file = event.currentTarget.files[0];
        if (file) {
            setFieldValue("user_img", file);

            const reader = new FileReader();
            reader.onload = () => {
                setFieldValue("user_img_mod", reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleVerify = () => {
        // Add verification logic here
        setIsVerified(true);
        closeModal();
    };

    const { values, handleChange, handleBlur, touched, errors, handleSubmit, resetForm, setValues, setTouched } = formik;
    return (
        <section className="pb-3">
            <ToastContainer position="top-center" />
            <div className="container mt-3 ">
                <form onSubmit={formik.handleSubmit}>
                    <div className="card mb-2">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 col-lg-6">
                                    <h5>General Information</h5>
                                    <div className="form-group ">
                                        <label>
                                            First Name <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-grp">
                                            <input
                                                type="text"
                                                className="form-control bg-7"
                                                name="first_name"
                                                value={formik.values.first_name}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.first_name && formik.errors.first_name && (
                                                <div className="text-danger">{formik.errors.first_name}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>
                                            Gender <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-grp">
                                            <select
                                                className="form-control bg-7"
                                                name="gender"
                                                value={formik.values.gender}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            >
                                                <option value="">Select Gender</option>
                                                <option value="1">Male</option>
                                                <option value="2">Female</option>
                                            </select>
                                            {formik.touched.gender && formik.errors.gender && <div className="text-danger">{formik.errors.gender}</div>}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>Update Profile</label>
                                        <div className="form-grp">
                                            <input
                                                className="form-control bg-7"
                                                type="file"
                                                // id="profileImage"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                                onBlur={formik.handleBlur}
                                                // style={{ display: "none" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-6">
                                    <h5 className="d-sm-none d-md-none d-lg-block">&nbsp;</h5>
                                    <div className="form-group ">
                                        <label>
                                            Last Name <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-grp">
                                            <input
                                                type="text"
                                                className="form-control bg-7"
                                                name="last_name"
                                                value={formik.values.last_name}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.last_name && formik.errors.last_name && (
                                                <div className="text-danger">{formik.errors.last_name}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>
                                            DOB <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-grp">
                                            <input
                                                type="date"
                                                className="form-control bg-7"
                                                name="dob"
                                                value={formik.values.dob}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.dob && formik.errors.dob && <div className="text-danger">{formik.errors.dob}</div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card mt-3">
                        <div className="card-body">
                            <div className="row">
                                <h5>Contact Information</h5>
                                <div className="col-md-12 col-lg-6">
                                    <div className="form-group">
                                        <label>
                                            Email Address <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-grp">
                                            <input
                                                type="email"
                                                className="form-control bg-7"
                                                name="user_email"
                                                value={formik.values.user_email}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.user_email && formik.errors.user_email && (
                                                <div className="text-danger">{formik.errors.user_email}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>
                                            Address Line 1 <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-grp">
                                            <input
                                                type="text"
                                                className="form-control bg-7"
                                                name="address_line1"
                                                value={formik.values.address_line1}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.address_line1 && formik.errors.address_line1 && (
                                                <div className="text-danger">{formik.errors.address_line1}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>
                                            City <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-grp">
                                            <input
                                                type="text"
                                                className="form-control bg-7"
                                                name="city"
                                                value={formik.values.city}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.city && formik.errors.city && <div className="text-danger">{formik.errors.city}</div>}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>
                                            Country <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-grp">
                                            <input
                                                type="text"
                                                className="form-control bg-7"
                                                name="country"
                                                value={formik.values.country}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.country && formik.errors.country && <div className="text-danger">{formik.errors.country}</div>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-6">
                                    <div className="form-group">
                                        <label>
                                            Phone Number <span className="text-danger">*</span>
                                        </label>

                                        <div className="form-grp">
                                            <PhoneInput
                                                // inputStyle={{ width: "100%" }}
                                                countryCodeEditable={false}
                                                id="phone"
                                                name="phone"
                                                country="us"
                                                value={values.phone}
                                                inputClass="form-control"
                                                onlyCountries={["us"]}
                                                onChange={(value, data) => {
                                                    setFieldValue("phone", value);
                                                }}
                                                onBlur={(e) => {
                                                    const event = {
                                                        target: {
                                                            name: "phone",
                                                            value: e.target.value,
                                                        },
                                                    };
                                                    handleBlur(event);
                                                    setTouched({ ...touched, phone: true });
                                                }}
                                            />
                                            {formik.touched.phone && formik.errors.phone && <div className="text-danger">{formik.errors.phone}</div>}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>
                                            Address Line 2 <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-grp">
                                            <input
                                                type="text"
                                                className="form-control bg-7"
                                                name="address_line2"
                                                value={formik.values.address_line2}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.address_line2 && formik.errors.address_line2 && (
                                                <div className="text-danger">{formik.errors.address_line2}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>
                                            State <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-grp">
                                            <input
                                                type="text"
                                                className="form-control bg-7"
                                                name="state"
                                                value={formik.values.state}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.state && formik.errors.state && <div className="text-danger">{formik.errors.state}</div>}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>
                                            Zip Code <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-grp">
                                            <input
                                                type="text"
                                                className="form-control bg-7"
                                                name="zip_code"
                                                value={formik.values.zip_code}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.zip_code && formik.errors.zip_code && <div className="text-danger">{formik.errors.zip_code}</div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card mt-3">
                        <div className="card-body">
                            <div className="row">
                                <h5>Social Information</h5>
                                <div className="col-md-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="form-label">Facebook</label>
                                        <div className="form-grp">
                                            <input
                                                type="url"
                                                className="form-control bg-7"
                                                name="facebook"
                                                value={formik.values.facebook}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.facebook && formik.errors.facebook && <div className="text-danger">{formik.errors.facebook}</div>}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Twitter</label>
                                        <div className="form-grp">
                                            <input
                                                type="url"
                                                className="form-control bg-7"
                                                name="twitter"
                                                value={formik.values.twitter}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.twitter && formik.errors.twitter && <div className="text-danger">{formik.errors.twitter}</div>}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label">Instagram</label>
                                        <div className="form-grp">
                                            <input
                                                type="url"
                                                className="form-control bg-7"
                                                name="instagram"
                                                value={formik.values.instagram}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.instagram && formik.errors.instagram && (
                                                <div className="text-danger">{formik.errors.instagram}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="form-label">Website</label>
                                        <div className="form-grp">
                                            <input
                                                type="url"
                                                className="form-control bg-7"
                                                name="website"
                                                value={formik.values.website}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.website && formik.errors.website && <div className="text-danger">{formik.errors.website}</div>}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Pinterest</label>
                                        <div className="form-grp">
                                            <input
                                                type="url"
                                                className="form-control bg-7"
                                                name="pinterest"
                                                value={formik.values.pinterest}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.pinterest && formik.errors.pinterest && (
                                                <div className="text-danger">{formik.errors.pinterest}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label">LinkedIn</label>
                                        <div className="form-grp">
                                            <input
                                                type="url"
                                                className="form-control bg-7"
                                                name="linkedin"
                                                value={formik.values.linkedin}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.linkedin && formik.errors.linkedin && <div className="text-danger">{formik.errors.linkedin}</div>}
                                        </div>
                                    </div>
                                    {/* <div className="form-group">
                                        <label>Google+</label>
                                        <div className="form-grp">
                                            <input
                                                type="url"
                                                className="form-control bg-7"
                                                name="google"
                                                value={formik.values.google}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />

                                            {formik.errors.google && formik.touched.google && <div className="text-danger">{formik.errors.google}</div>}
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="btn-user mt-2 ">
                        <button type="submit" className="btn text-white btn-dark rounded-3 mt-2" disabled={formik.isSubmitting}>
                            Save
                        </button>
                    </div>
                </form>
            </div>

            {/* Modal for verification */}
            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Verification Modal"
                ariaHideApp={false}
                className="Modal"
                overlayClassName="Overlay"
            >
                <h2>Verification</h2>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleVerify();
                    }}
                >
                    <div className="form-group">
                        <label>Verification Code</label>
                        <input
                            type="text"
                            className="form-control"
                            name="verificationCode"
                            value={formik.values.verificationCode}
                            onChange={formik.handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label>Transaction Password</label>
                        <input
                            type="password"
                            className="form-control"
                            name="transactionPassword"
                            value={formik.values.transactionPassword}
                            onChange={formik.handleChange}
                        />
                    </div>
                    <button type="submit" className="btn btn-dark text-white mt-2">
                        Verify
                    </button>
                    <button type="button" className="btn btn-light mt-2 ms-2" onClick={closeModal}>
                        Close
                    </button>
                </form>
            </Modal>
            <style jsx>
                {`
                    .Modal {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        padding: 20px;
                        max-width: 500px;
                        width: 100%;
                        background: white;
                        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
                        border-radius: 8px;
                    }

                    .Overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                `}
            </style>
            <style jsx>
                {`
                    .form-group {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                    .form-grp {
                        position: relative;
                    }
                    .error-msg {
                        position: absolute;
                        font-size: 12px;
                    }
                `}
            </style>
        </section>
    );
};

export default EditUserProfile;
